import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
// import { ChatPage } from './chat/chat';
// import { CollectionsPage } from './modules/collections/components/collections/collections';
import { SupportPage } from './support/support';
import { QuizResultsComponent } from './modules/chat/components/chat/quiz-results/quiz-results';

export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: "items" },
    { path: 'support', component: SupportPage },
    { path: 'games', loadChildren: () => import('./modules/games/games-routing').then(m => m.GAMES_ROUTES) },
    { path: 'invite', loadChildren: () => import('./modules/invitation/invitation.module').then(m => m.InvitationModule) },
    { path: 'contact', loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactModule) },
    { path: 'settings', loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule) },
    { path: 'profile', loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule) },
    { path: 'items', loadChildren: () => import('./modules/items/items.module').then(m => m.ItemsModule) },
    { path: 'chat', loadChildren: () => import('./modules/chat/chat-routing.module').then(m => m.CHAT_ROUTES) },
    { path: 'dict', loadChildren: () => import('./dict-page/dict-page.module').then(m => m.DictPageModule) },
    { path: 'collections', loadChildren: () => import('./modules/collections/collections.module').then(m => m.CollectionsModule) },
    { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) },
    { path: 'ocr-reader', loadComponent: () => import('./components/ocr-reader/ocr-reader.component').then(m => m.OcrReaderComponent) },
    {
        path: 'quiz-results/:chatId',
        component: QuizResultsComponent
    },
    { path: 'subscription', loadChildren: () => import('./modules/subscription/subscription-routing.module').then(m => m.SUBSCRIPTION_ROUTES) },

];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
